import { useDispatch } from '@bonanza-social/toolkit/state';
import { Navigate } from 'react-router';
import { openSocialRegistrationModal } from '../state/registrationForm/socialRegistrationForm.slice';
import { useEffect } from 'react';

function SocialRegistrationPage() {
  const dispatch = useDispatch();

  useEffect(() => () => {
    dispatch(openSocialRegistrationModal());
  });

  return <Navigate to="/" replace />;
}

export default SocialRegistrationPage;
